import Streaming from '../streaming/streaming';
import {initTopBottom} from "../modulos/topbottom/topbottom";
import analisisMasVistos from "../modulos/analisisMasVistos/analisisMasVistos";
import instrumentBox from "../modulos/instrumentBox/instrumentBox";
import {marketComponentsSelector} from "../modulos/quotes/marketSelector";
import {streamingConnector} from "../modulos/quotes/streamingConnector";
import importantQuotes from "../modulos/importantQuotes/importantQuotes";
import {premiumFAMultiple} from "../modulos/quotes/premiumFAMultiple";
import {tableSwiper} from "../modulos/swiper/swiper";

/**
 * Partes comunes entre fichas de cotización y listado y páginas relacionados con cotizaciones
 */
export const commonQuotesAndStockDetail = () => {
    console.log('Loading quotes-stockdetail components');
    import('./css/quotes-and-stockdetail.scss');

    //Conectar con Streaming
    streamingConnector();

    //Análisis fundamental
    premiumFAMultiple();

    //Swiper.
    // tableSwiper();

    //Cotizaciones superiores (antigua marquesina)
    importantQuotes(Streaming);

    //Inicializa los módulos de top/flops
    initTopBottom(Streaming);

    //Módulo de análisis más vistos
    analisisMasVistos();
}

//Carga los "listados y páginas" relacionadas con cotizaciones.
// NO FICHAS COMPLETAS
export const loadQuotes = () => {
    console.log('Loading quotes components');
    //Funciones comunes entre listados y páginas de cotización
    commonQuotesAndStockDetail();

    //InstrumentBox
    instrumentBox(Streaming);

    //Módulo "Ver componentes por mercado"
    marketComponentsSelector();
}
